<template>
  <div>
    <p class="widget-auth-info">Fortnox</p>
    <br />
    <br />
    <b-row>
      <b-col md="6">
        <h4 class="text-center">
          {{ $tc("areYouCuriousAboutPrewoe") }}
        </h4>
        <br />
        <p class="text-center">
          {{ $tc("testFor14DaysFortnoxInfo") }}
          <br />
          <br />
          <b-button variant="outline-secondary" @click="register">
            <span class="icon">
              <i>{{ $tc("signUp") }}</i>
            </span>
          </b-button>
        </p>
      </b-col>
      <b-col md="6">
        <h4 class="text-center">
          {{ $tc("areYouAlreadyPrewoeCustomer") }}
        </h4>
        <br />
        <p class="text-center">
          {{ $tc("connectSystemsFortnoxInfo") }}
          <br />
          <br />
          <br />
          <b-button variant="outline-secondary" @click="login">
            <span class="icon">
              <i>{{ $tc("login") }}</i>
            </span>
          </b-button>
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "PreFortnoxView",
  components: {},
  data() {
    return {
      showInfo: false,
      id: this.$route.params.id,
      fortnoxInfo: null
    };
  },
  mounted() {},
  methods: {
    register() {
      var query = this.$route.query;
      this.$router.push({
        name: "register",
        query: { "fortnox-authorization-code": query["authorization-code"] }
      });
    },
    login() {
      var query = this.$route.query;
      this.$router.push({
        name: "login",
        query: { "fortnox-authorization-code": query["authorization-code"] }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
